import { Button, Col, Image, Row, Typography } from "antd";
import Container from "components/Common/Container";
import TImage from "components/Common/TImage";
import PublicFooter from "components/Layouts/Public/PublicFooter/PublicFooter";
import PublicLayout, {
  signupRedirect,
} from "components/Layouts/Public/PublicLayout";
import PublicNav from "components/Layouts/Public/PublicNav/PublicNav";
import PricingSEO from "components/PublicPages/Pricing/PricingSEO";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { HiArrowRight } from "react-icons/hi";
import "swiper/scss";
import { Analytics } from "utils/Analytics/AnalyticsHelper";

const PricingTable = dynamic(
  () => import("components/PublicPages/Pricing/PricingTable"),
  {
    ssr: false,
  }
);

const PricingTestimonials = dynamic(
  () => import("components/PublicPages/Pricing/PricingTestimonials"),
  {
    ssr: false,
  }
);
const FAQHome = dynamic(
  () => import("components/PublicPages/Homepage/FAQHome"),
  {
    ssr: false,
  }
);

const { Paragraph, Title } = Typography;

const Pricing: React.FC = () => {
  const debounce = (callback, wait) => {
    let timeoutId: any = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
      }, wait);
    };
  };
  // const { data: country, isLoading: countryLoading } = useQuery(
  //   [APIStateKeysEnum.Country],
  //   () => getCountry()
  // );

  const goToPrice = () => {
    const priceDiv = document.getElementById("price");
    priceDiv && priceDiv.scrollIntoView({ behavior: "smooth" });
  };
  const router = useRouter();
  const [currentScrollPos, setCurrentScrollPos] = useState(0);
  const [darkScroll, setDarkScroll] = useState(false);

  const handleScroll = debounce(() => {
    const currentScrollPos = window.pageYOffset;
    setCurrentScrollPos(currentScrollPos);
    const elementPos = document.getElementById("price");
    if (elementPos && currentScrollPos > elementPos?.offsetTop) {
      setDarkScroll(true);
    } else {
      setDarkScroll(false);
    }
  }, 50);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <PublicLayout>
      <Container className="pricing" type="fluid">
        {/* SEO */}
        <PricingSEO />
        {/* Common Nav */}
        <PublicNav page="common" theme={darkScroll ? "light" : "dark"} />

        {/* Main Hero Section */}
        <Container type="fluid">
          <Col
            xs={{ span: 24, offset: 0 }}
            md={{ span: 24, offset: 0 }}
            className="exploring"
          >
            <Title level={1} className="exploring-text">
              Whether you&apos;re exploring or a pro, we have you covered
            </Title>
            <Paragraph className="go-to-price" onClick={goToPrice}>
              <Image
                src="/images/public-profile/arrow-down-circle.svg"
                preview={false}
                alt="Scroll Down"
                width={60}
                height={60}
              />
              <Paragraph className="see-pricing">See pricing</Paragraph>
            </Paragraph>
          </Col>
        </Container>

        <Container type="fluid" id="price">
          <Row>
            <Col
              xs={{ span: 24, offset: 0 }}
              md={{ span: 24, offset: 0 }}
              className="utility"
            >
              <Paragraph className="heading-utility">Simple pricing</Paragraph>
              <Paragraph className="creator-price">7% commission</Paragraph>
              <Paragraph className="desc-utility">
                No upfront fees. Flat 7% commission + transaction fees. We
                charge a small commission on your earnings so that we earn only
                when you earn
              </Paragraph>
              <Paragraph
                className="lifetime-tag cursor-hover"
                onClick={() => {
                  Analytics.track("invite_clicked", {
                    Position: "7% Commission",
                    Type: "Pricing",
                    Pricing: "Flat",
                    Value: 7,
                  });
                  router.push(signupRedirect());
                }}
              >
                <Paragraph className="main-text">Get started free</Paragraph>
                <HiArrowRight
                  color="#000"
                  fontSize={24}
                  style={{ marginLeft: 15 }}
                />
                {/* <Paragraph className="main-text">Lifetime free</Paragraph> */}
                {/* <Paragraph className="text">till humanity exist</Paragraph> */}
              </Paragraph>
            </Col>
            {/* <Col
              xs={{ span: 24, offset: 0 }}
              md={{ span: 12, offset: 0 }}
              className="creator"
            >
              <Paragraph className="heading-creator">CREATOR +</Paragraph>
              <Paragraph className="creator-price">
                $15/m
              </Paragraph>
              <Paragraph className="desc-utility">
                Skip any commissions. You keep 100% of your earnings, minus the
                transaction charges. Reach out to{" "}
                <Link href="https://topmate.io/yash_jakhete/39670/pay">
                  know more
                </Link>
                .
                <br />
                <br />
              </Paragraph>
              <Paragraph
                className="lifetime-tag cursor-hover"
                onClick={() => {
                  Analytics.track("invite_clicked", {
                    Position: "Lifetime tag deadline",
                    Type: "Pricing",
                    Pricing: "Paid",
                    Value: 15,
                  });
                  router.push(signupRedirect());
                }}
              >
                <Paragraph className="main-text">Go pro</Paragraph>
                <HiArrowRight
                  color="#000"
                  fontSize={24}
                  style={{ marginLeft: 15 }}
                />
              </Paragraph>
            </Col> */}
          </Row>
        </Container>

        {/* Features */}
        <Container type="fluid" className="pricing-features">
          <Container>
            <Paragraph className="title">
              Creators on Topmate earn{" "}
              <span style={{ color: "#9BCF60" }}>73%</span> more
            </Paragraph>

            {/* Desktop */}
            <Col xs={0} md={24}>
              <Row gutter={20}>
                <Col span={16} style={{ display: "grid", gap: 20 }}>
                  <Row gutter={20}>
                    <Col span={10}>
                      <TImage
                        src="/images/pricing/pricing-features-1.svg"
                        alt="Collect Payments Globally"
                        className="img-services"
                        width={100}
                      />
                    </Col>
                    <Col span={14}>
                      <TImage
                        src="/images/pricing/pricing-features-2.svg"
                        alt="Highlight Unlimited Testimonials"
                        className="img-services"
                        width={100}
                      />
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col span={15}>
                      <TImage
                        src="/images/pricing/pricing-features-3.svg"
                        alt="Showcase your social handles"
                        className="img-services"
                        width={100}
                      />
                    </Col>
                    <Col span={9}>
                      <TImage
                        src="/images/pricing/pricing-features-4.svg"
                        alt="Full stack scheduling"
                        className="img-services"
                        width={100}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={8}>
                  <TImage
                    src={"/images/pricing/pricing-features-5.svg"}
                    alt="Host Unlimited Services"
                    className="img-services"
                    width={100}
                  />
                </Col>
              </Row>
            </Col>

            {/* Mobile */}
            <Col xs={{ span: 22, offset: 1 }} md={{ span: 0, offset: 0 }}>
              <Row gutter={20}>
                <Col span={24}>
                  <TImage
                    src="/images/pricing/pricing-features-mobile-1.svg"
                    alt="Collect Payments Globally"
                    className="img-services"
                    width={100}
                  />
                </Col>
                <Col span={24}>
                  <TImage
                    src="/images/pricing/pricing-features-mobile-2.svg"
                    alt="Highlight Unlimited Testimonials"
                    className="img-services"
                    width={100}
                  />
                </Col>
                <Col span={24}>
                  <TImage
                    src="/images/pricing/pricing-features-mobile-3.svg"
                    alt="Showcase your social handles"
                    className="img-services"
                    width={100}
                  />
                </Col>
                <Col span={24}>
                  <TImage
                    src="/images/pricing/pricing-features-mobile-4.svg"
                    alt="Full stack scheduling"
                    className="img-services"
                    width={100}
                  />
                </Col>
                <Col span={24}>
                  <TImage
                    src={"/images/pricing/pricing-features-mobile-5.svg"}
                    alt="Host Unlimited Services"
                    className="img-services"
                    width={100}
                  />
                </Col>
              </Row>
            </Col>
          </Container>
        </Container>

        <Container type="fluid" className="pricing-services">
          <Container>
            <Title level={2} className="title">
              Convenient, privacy focused and supported globally
            </Title>
            <Row justify="center" gutter={{ xs: 0, md: 40 }}>
              <Col
                xs={{ span: 22, offset: 0 }}
                md={{ span: 8, offset: 0 }}
                className="ps-block"
              >
                <TImage
                  src={"/images/pricing/pricing-services-1.svg"}
                  alt="Smart reminders"
                  width={250}
                  height={250}
                />
                <Title level={3} className="ps-title">
                  Smart reminders
                </Title>
                <Title level={4} className="ps-subtitle">
                  {`you can't imagine how seamless your life can be`}
                </Title>
              </Col>
              <Col xs={22} md={8} className="ps-block">
                <TImage
                  src={"/images/pricing/pricing-services-2.svg"}
                  alt="Masked emails"
                  width={250}
                  height={250}
                />
                <Title level={3} className="ps-title">
                  Masked emails
                </Title>
                <Title level={4} className="ps-subtitle">
                  {`because we know privacy matters to you`}
                </Title>
              </Col>
              <Col xs={22} md={8} className="ps-block">
                <TImage
                  src={"/images/pricing/pricing-services-3.svg"}
                  alt="Collect payments globally"
                  width={250}
                  height={250}
                />
                <Title level={3} className="ps-title">
                  Collect payments globally
                </Title>
                <Title level={4} className="ps-subtitle">
                  {`build your global creator business`}
                </Title>
              </Col>
            </Row>
          </Container>
        </Container>

        <Container>
          <Row align="middle" justify="center">
            <Col
              xs={{ span: 22, offset: 0 }}
              md={{ span: 12, offset: 0 }}
              className="comparison"
            >
              <Paragraph className="heading">COMPARISION</Paragraph>
              <Paragraph className="text">
                Here&apos;s why we edge past others
              </Paragraph>
            </Col>
            <Col
              xs={{ span: 22, offset: 0 }}
              md={{ span: 12, offset: 0 }}
              className="aim"
            >
              <Paragraph className="desc-aim">
                At topmate the aim is to <b>always challenge the status quo</b>{" "}
                and create scalable solutions that don&apos;t burn holes in the
                pocket.
              </Paragraph>
            </Col>
          </Row>
        </Container>

        {/* Pricing Table */}
        <PricingTable />

        <Button
          size="large"
          className="btn-dark pricing-signup"
          onClick={() => {
            Analytics.track("invite_clicked", {
              Position: "Below price comparison",
              Type: "Pricing",
            }),
              router.push(signupRedirect());
          }}
        >
          Get Started
          <HiArrowRight color="#fff" fontSize={24} style={{ marginLeft: 15 }} />
        </Button>

        {/* Testimonials */}
        <PricingTestimonials />

        {/* FAQ */}
        <FAQHome />

        {/* Footer */}
        <PublicFooter />
      </Container>
    </PublicLayout>
  );
};

export default Pricing;
